/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { Pmo } from '@scenario/models/pmo.model';
import { RootState } from '@store/create-store';
import {
  retrievePmosFailure,
  retrievePmosSuccess,
} from '@store/scenario/pmo/pmo-slice';

export const retrievePmosEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType('pmo/retrievePmos'),
  concatMap(() => from(dependencies.pmoGateway.retrieveAll()).pipe(
    map((pmos: Pmo[]) => retrievePmosSuccess(pmos)),
    catchError(() => of(retrievePmosFailure('Failed to retrieve PMOs'))),
  )),
);

